<template>
  <div v-if="isLoading" class="mc-loading-overlay" :style="overlayStyle">
    <div v-if="!getLoaderLogoPath" class="mc-loading-spinner" />
    <img
      v-else
      :src="getLoaderLogoPath"
      :alt="alt"
      class="mc-loading-logo mc-loading-logo--blinking"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'McLoading',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    logoPath: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: 'Loading...',
    },
    overlayColor: {
      type: String,
      default: 'rgba(255, 255, 255, 0.8)',
    },
    zIndex: {
      type: [String, Number],
      default: 9999,
    },
    fixed: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
    }),
    getLoaderLogoPath() {
      return this.logoPath || this.getAsset('secondaryLogo', 'sidebarMinimize')
    },
    overlayStyle() {
      return {
        backgroundColor: this.overlayColor,
        zIndex: this.zIndex,
        position: this.fixed ? 'fixed' : 'absolute',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mc-loading-overlay {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mc-loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: mc-loading-spin 2s linear infinite;
}

.mc-loading-logo {
  max-width: 100px;
  max-height: 100px;
}

.mc-loading-logo--blinking {
  animation: mc-loading-blink 1s infinite;
}

@keyframes mc-loading-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes mc-loading-blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>
